<template>
  <div class="mt-3 mt-md-4">
    <div class="font-size-sm font-weight-bold color-text-dark">
      {{ i18n.optional }}
    </div>

    <div
      v-for="option in cartItem.options"
      :key="option.id"
      class="accommodation-option mt-3"
    >
      <input
        type="checkbox"
        :id="`cart-item-option-${option.id}`"
        :name="`cart-item-option-${option.id}`"
        :value="true"
        :checked="option.selectedOption || option.selected"
        :disabled="option.disabled"
        @change="({ currentTarget }) => onCartItemOptionChange([
          currentTarget.checked,
          cartItem,
          option.id,
        ])"
      >

      <label :for="`cart-item-option-${option.id}`">
        {{ option.title }}

        <span v-if="option.value" class="color-primary font-weight-bold">
          {{ option.value }}
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    cartItem: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions([
      'onCartItemOptionChange',
    ]),
  },
};
</script>
